import { render } from "./WrapPeercoin.vue?vue&type=template&id=f375f0d0&scoped=true"
import script from "./WrapPeercoin.vue?vue&type=script&lang=js"
export * from "./WrapPeercoin.vue?vue&type=script&lang=js"

import "./WrapPeercoin.vue?vue&type=style&index=0&id=f375f0d0&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-f375f0d0"

export default script